import React from 'react';
import { CopyButton } from '@components/common/CopyButton';
import { Button, Input, useCopyToClipboard, useMediaQueryContext } from '@fourthwall/components';
import { TickIcon } from '@fourthwall/icons';
import { isGiftCardGroup } from '../../utils/isGiftCardGroup';
import { isGiftCardSingle } from '../../utils/isGiftCardSingle';
import * as S from './GiftCardShareBanner.styled';
export const GiftCardShareBanner = ({ giftCard }) => {
    const media = useMediaQueryContext();
    const { copyToClipboard } = useCopyToClipboard({
        toastMessage: 'Gift card codes copied to clipboard',
    });
    const getTitle = () => {
        if (isGiftCardSingle(giftCard)) {
            return 'Gift card created. What’s next?';
        }
        return 'Gift cards created. What’s next?';
    };
    const getDescription = () => {
        if (isGiftCardSingle(giftCard)) {
            return 'The code can now be used during checkout. Copy or send the code to share it.';
        }
        return 'You can now share your gift cards with supporters!';
    };
    const handleCopyCodes = () => {
        if (!isGiftCardGroup(giftCard))
            return;
        const codes = giftCard.giftCards.map((giftCard) => giftCard.code).join('\n');
        if (codes) {
            copyToClipboard(codes);
        }
    };
    const renderGiftCardSingleFooter = () => {
        if (!isGiftCardSingle(giftCard))
            return null;
        return (React.createElement(Input, { readOnly: true, value: giftCard.code, size: "small", actionIcon: React.createElement(CopyButton, { copyText: giftCard.code, iconSize: 16 }) }));
    };
    const renderGiftCardGroupFooter = () => {
        return (React.createElement(Button, { appearance: "secondary", size: "small", label: "Copy all codes to clipboard", onClick: handleCopyCodes }));
    };
    const renderTick = () => {
        return (React.createElement(S.TickContainer, null,
            React.createElement(TickIcon, { height: 10 })));
    };
    return (React.createElement(S.Container, null,
        media.tablet && renderTick(),
        React.createElement(S.Content, null,
            React.createElement(S.Title, null,
                !media.tablet && renderTick(),
                getTitle()),
            React.createElement(S.Description, null, getDescription()),
            React.createElement(S.Footer, null,
                isGiftCardSingle(giftCard) && renderGiftCardSingleFooter(),
                isGiftCardGroup(giftCard) && renderGiftCardGroupFooter()))));
};
